export default __webpack_public_path__ + "static/media/loading-text.8923804b.png";